import React, { useEffect, useMemo, useState } from 'react'
import BlogHero from '../../components/Blog/BlogHero'
import BlogList from '../../components/Blog/BlogList'
import { blogPosts } from '../../data/blogPosts.jsx'
import NewsletterCTA from '../../components/About/NewsletterCTA'
import Footer from '../../components/landing/Footer'
import GuestNavbar from '../../components/navigations/GuestNavbar'
export default function BlogAll() {
  const [query, setQuery] = useState('')
  useEffect(()=>{ window.scrollTo(0,0); },[])

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (!q) return blogPosts
    return blogPosts.filter(p =>
      p.title.toLowerCase().includes(q) ||
      p.excerpt.toLowerCase().includes(q) ||
      p.topic.toLowerCase().includes(q)
    )
  }, [query])

  return (
    <>
    <GuestNavbar/>
      <BlogHero onSearch={setQuery} showBack />
      <section className="pb-16">
        <div className="px-6 mx-auto max-w-6xl">
          <BlogList posts={filtered} />
        </div>
      </section>
      <NewsletterCTA/>
      <Footer/>
    </>
  )
}


